import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BrandDto } from 'app/models/brand-dto';
import { BrandResponse } from 'app/models/BrandResponse';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BrandService {
  private get apiUrl(): string {
    const base = localStorage.getItem('apiURL');
    if (!base) throw new Error('apiURL not ready');
    return base + "/api/v2" ;
  }
  constructor(private http:HttpClient) 
  { }
  // getBrands(page: number = 0, storeId: number = 1, userId: number = 1, languageCode: string = 'en'): Observable<BrandResponse> {
  //     return this.http.get<BrandResponse>(`${this.apiUrl}/brands?page=${page}`);
  //   }

    getBrands(
    page: number = 1,
    pageSize: number = 10,
    search: string = '',
    languageCode: string = 'en'
  ): Observable<BrandResponse> {
      let url = `${this.apiUrl}/brands?page=${page}&perPage=${pageSize}`;
        if (search) {
    url += `&search=${search}`;
  }

    return this.http.get<BrandResponse>(url);
  }

     getBrandBySlug(slug : string): Observable<BrandDto> {
      return this.http.get<BrandDto>(`${this.apiUrl}/brands/slug/${slug}`);
    }
    deleteBrandBySlug(slug : string): Observable<BrandResponse> {
      return this.http.delete<BrandResponse>(`${this.apiUrl}/brands/slug/${slug}`);
    }

    updateBrand(slug:string,form: any): Observable<BrandResponse> {
      const formData = new FormData();
    console.log(form);
      Object.keys(form).forEach(key => {
        const value = form[key];
        if (value !== null && value !== undefined) {
          if (value instanceof File) {
            formData.append(key, value, value.name);
          } else {
            formData.append(key, value.toString());
          }
        }
      });
    
      // 🔍 للتأكد أثناء التجربة
      formData.forEach(element=>{
    console.log(element);
      }) 
        
      
    
      return this.http.put<BrandResponse>(
        `${this.apiUrl}/brands/slug/${slug}`,
        formData
      );
    }

updateBrandFlags(slug: string, data: { status?: boolean; top?: boolean }) {
  return this.http.put(`${this.apiUrl}/brands/slug/${slug}/flags`, data);
}


    createBrand(form: any): Observable<BrandResponse> {
      const formData = new FormData();
    
      Object.keys(form).forEach(key => {
        const value = form[key];
        if (value !== null && value !== undefined) {
          if (value instanceof File) {
            formData.append(key, value, value.name);
          } else {
            formData.append(key, value.toString());
          }
        }
      });
    
      // 🔍 للتأكد أثناء التجربة
      formData.forEach(element=>{
    console.log(element);
      }) 
        
      
    
      return this.http.post<BrandResponse>(
        `${this.apiUrl}/brands`,
        formData
      );
    }
}
